module.exports = __webpack_public_path__ + "img/bread-concept.6e3c9445.png";